var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBill = function SvgBill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 0H6v8h14V0zm-7 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5c0 .8-.7 1.5-1.5 1.5H1v-7.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v2.4l4.4-4.4c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1L6.1 16h2.4c.8 0 1.5.7 1.5 1.5z"
  })));
};
export default SvgBill;